import React from 'react';
import Button from '@mui/material/Button';

const CommonButton = ({ text, onClick, icon, type, className, color, size, disabled = false, fullWidth = false, bgColor,
}) => {
    return (
        <Button
            type={type}
            className={className}
            variant="contained"
            size={size || "medium"}
            onClick={onClick}
            disabled={disabled}
            fullWidth={fullWidth}
            sx={{
                color: color,
                textTransform: 'none',
                padding: '10px 20px',
                fontFamily: "Poppins",
                background: bgColor || "linear-gradient(to bottom, #000000 0%, #40330D 100%)",
                '&:hover': {
                    backgroundColor: bgColor ? `${bgColor}80` : "",
                },
            }
            }
        >
            {icon} {text}
        </Button >
    );
};

export default CommonButton;

